export default __webpack_public_path__ + "static/media/buildButton.cf056419.png";